/**
 * Injection key for Shell Contracts (used with Vue's provide/inject)
 */
export const SHELL_CONTRACTS_KEY = Symbol("SHELL_CONTRACTS_KEY");
